import { useCallback } from "react";
import { useProfile } from "../contexts/ProfileContext";
import {
  formatDate as rawFormatDate,
  type DateInput,
  type DateFormatPreset,
} from "../lib/dates";

export function useDateFormatter() {
  const { profile } = useProfile();

  const formatDate = useCallback(
    (input: DateInput, preset: DateFormatPreset = "date") =>
      rawFormatDate(input, preset, {
        timezone: profile?.timezone,
        locale: profile?.locale,
      }),
    [profile?.timezone, profile?.locale]
  );

  return { formatDate };
}
